import * as React from 'react';

import classNames from 'classnames';

import { humanizeLearningTime } from 'js/utils/DateTimeUtils';

type Props = {
  timeCommitment: number;
  className?: string;
};

class TimeCommitment extends React.Component<Props> {
  render() {
    const { timeCommitment, className } = this.props;

    return (
      <span className={classNames(className, 'color-secondary-text caption-text')}>
        {humanizeLearningTime(timeCommitment)}
      </span>
    );
  }
}

export default TimeCommitment;
